exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".slimScrollDiv {\n  position: relative;\n  overflow: hidden;\n  width: auto;\n  height: 870px; }\n  .slimScrollDiv .slimscrollleft {\n    overflow: hidden;\n    width: auto;\n    height: 870px; }\n  .slimScrollDiv .profile-info {\n    padding: 10px 0px 10px 0px; }\n    .slimScrollDiv .profile-info img {\n      width: 45px;\n      height: 45px; }\n\n.slimScrollBar {\n  background: #7a868f;\n  width: 5px;\n  position: absolute;\n  top: 0;\n  opacity: 0.4;\n  display: none;\n  border-radius: 7px;\n  z-index: 99;\n  left: 1px;\n  height: 870px;\n  visibility: visible; }\n\n.slimScrollRail {\n  width: 5px;\n  height: 100%;\n  position: absolute;\n  top: 0px;\n  display: none;\n  border-radius: 7px;\n  background: #333333;\n  opacity: 0.2;\n  z-index: 90;\n  left: 1px; }\n\n.list-styled {\n  list-style-type: circle;\n  color: #343838; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/layouts/left-sidemenu/left-sidemenu.component.scss
// module id = ../../../../../src/app/layouts/left-sidemenu/left-sidemenu.component.scss
// module chunks = main